module.exports = __webpack_public_path__ + "img/303.png";